// @flow

import { toJS } from 'mobx';
import React, { Component } from 'react';
import { observer } from 'mobx-react';
import PageIntro from '~/src/components/PageIntro';
import EditorLink from '~/src/components/EditorLink';
import EventLog from './EventLog';
import t from '~/src/services/i18n';
import './EventsAndAnalytics.scss';

declare var cloudinary: any;

type Props = {
  config: Object,
  events: Array<Object>,
  eventsList: Array<string>,
  addEvent: Function,
  setFormConfig: Function,
}

@observer
class EventsAndAnalytics extends Component<Props> {
  myWidget: Object = {};

  handleEvents() {
    this.props.eventsList.forEach(event => {
      this.myWidget.on(event, (data) => {
        this.props.addEvent(data);
      });
    });
  }
  componentDidMount(){
    this.myWidget = cloudinary.galleryWidget(toJS(this.props.config)); // eslint-disable-line
    this.myWidget.render();
    this.handleEvents();
  }
  componentWillUnmount() {
    this.myWidget.destroy();
  }

  render() {
    return (
      <div className="section events-and-analytics">
        <PageIntro page={'events'} />
        <h1>{t('easyToCustomize')}</h1>
        <div className="gallery">
          <div id="events-and-analytics-gallery"></div>
          <h2>{t('events')}</h2>
          <EventLog events={this.props.events} placeholders />
        </div>
        <EditorLink onClick={() => {
          this.props.setFormConfig(this.props.config);
        }}/>
      </div>
    );
  }
}

export default EventsAndAnalytics;
